import React, { Component } from "react";
import Notification from "../shared/notification";
import style from "../login/login.module.css";
import * as apiEndPoints from "../shared/apiPaths";
import * as routes from "../shared/routes";
import axios from "axios";
import { getErrorMessage } from "../shared/utils";
import * as Messages from "../shared/messages";
import analytics from "../shared/analytics"

class RecoverPassword extends Component {
  constructor(props) {
    super(props);
    analytics.pageView();
    this.state = { token: "", memberId: "", password: "" };
    this.formRef = React.createRef();
    this.passwordRef = React.createRef();
  }

  componentDidMount() {
    this.formRef.current.addEventListener("submit", e => this.submitHandler(e));
    const query = new URLSearchParams(this.props.location.search);
    const token = query.get("token");
    const memberId = query.get("u");
    this.setState({ token: token, memberId: memberId });
  }

  passwordChangedHandler = event => {
    const password = event.target.value;
    const passwordStrength = this.passwordStrengthCheck(password);
    const isValidPassword = passwordStrength >= 3 && password.length >= 8;
    this.passwordRef.current.valid = isValidPassword;
    this.setState({ password: password, isValid: isValidPassword });
  };

  passwordStrengthCheck(password) {
    let passwordStrengthCounter = 0;

    var matchedCase = [];
    matchedCase.push(".[!,@,#,$,%,^,&,*,?,_,~,-,£,(,)]"); // Special Charactor
    matchedCase.push("[A-Z]");      // Uppercase Alpabates
    matchedCase.push("[0-9]");      // Numbers
    matchedCase.push("[a-z]");     // Lowercase Alphabates

    for (var i = 0; i < matchedCase.length; i++) {
      if (new RegExp(matchedCase[i]).test(password)) {
        passwordStrengthCounter++;
      }
    }
    return passwordStrengthCounter;
  }
  submitHandler = event => {
    if (this.state.isValid) {
      const url = window.ENV.LOGIN_API_ROOT + apiEndPoints.RESET_PASSWORD;

      axios
        .post(url, {
          password: this.state.password,
          token: this.state.token,
          memberId: this.state.memberId
        })
        .then(response => {
          this.onSuccess();
        })
        .catch(error => {
          const status = error.response ? error.response.status : 0;
          this.onFailure(getErrorMessage(error), status);
        });
    }
  };

  onSuccess = () => {
    Notification.showNotification("success", Messages.passwordChangeSuccess);
    this.props.history.push(routes.login);
  }

  onFailure = (message, status) => {
    const messageToDisplay = status === 403 ? Messages.invalidLink : message;
    Notification.showNotification("danger", messageToDisplay);
  }

  render() {
    let logoUrl = "https://cdn.svc.oneadvanced.com/mosaic/2.0.0/img/logo.svg";
    let logoAlt = "Advanced"
    if (process.env.NODE_ENV === 'production') {
      logoUrl = window.applicationIcon;
      logoAlt = window.applicationName;
    }
    return (
      <React.Fragment>
        <mosaic-page class={style.mosaicpage}>
          <mosaic-content-container>
            <mosaic-main-container fluid>
              <div className={style.pageBgOverlay} />
              <mosaic-card class={style.card}>
                <mosaic-card-body class="pb-0">
                  <div className={style.logo}>
                    <img
                      src={logoUrl}
                      alt={logoAlt}
                    />
                  </div>
                  <h1 className={style.appName}>
                    <span><mosaic-translation Key="app.company.name"></mosaic-translation></span>
                  </h1>
                  <h2 className={style.contentTitle}>Reset your Password</h2>
                  <div className="content">
                    <p className={style.strapline}>
                      Enter a new password below and once it has been successfully updated you can return to the login page to access the site.
                    </p>

                    <mosaic-form
                      ref={this.formRef}
                      class="form"
                      prevent-default
                      novalidate
                    >
                      <mosaic-password-input
                        name="Password"
                        block required prepend icon="password"
                        label="Password"
                        placeholder="Enter your password"
                        valid-text="Password is valid."
                        invalid-text="Password does not meet complexity requirements. Must be 8 or more characters and use at least three of the four available character types: lowercase letters, uppercase letters, numbers, and symbols."
                        onInput={this.passwordChangedHandler}
                        value={this.state.password}
                        ref={this.passwordRef}>
                      </mosaic-password-input>

                      <mosaic-form-actions>
                        <mosaic-button color="primary"
                          icon="recurring_appointment"
                          class="btn-block"
                          submit
                          block>
                          Reset password
                        </mosaic-button>
                      </mosaic-form-actions>
                    </mosaic-form>
                  </div>
                </mosaic-card-body>
                <mosaic-card-footer class="p-0">
                  <div className={style.loginFooter}>
                    <small className={style.small}>&copy;2019 Advanced</small>
                  </div>
                </mosaic-card-footer>
              </mosaic-card>
            </mosaic-main-container>
          </mosaic-content-container>
        </mosaic-page>
      </React.Fragment>
    );
  }
}

export default RecoverPassword;
